import {
  ServerActionWidget,
  SPI,
  ActionWidget,
  ActionType,
  ClickResult,
  RuntimeServerAction,
  SubmitValue,
  ActiveRecord
} from '@kunlun/dependencies';
import { OioNotification } from '@kunlun/vue-ui-antd';
// 递归校验子元素
/*
      校验字段 
      optionType ：'FULL_SUB' 满减 | 'FULL_GWP'满赠 | 'DIRECT_DESCENT'直降
      prevPriority 优先级
      hasPrecondition 前置条件 conditions 前置条件数组
      优先级校验 优先级
      effectConditions 门槛规格
      equityInformationRule 权益信息 discountValue
*/
const validateChild = (childrenData: any) => {
  if (childrenData['hasPrecondition']) {
    // 判断是否有前置条件
    if (childrenData['conditions'].length == 0) {
      // 前置条件数组
      return false;
    } else {
      for (let index = 0; index < childrenData['conditions'].length; index++) {
        let conditionsItem = childrenData['conditions'][index];
        // FULL_AMOUNT FULL_PAYMENT FULL_QUANTITY 三种情况下都需要判断 optionValue
        if (conditionsItem['optionValue'] === '' || conditionsItem['optionValue'] == 'undefined') {
          return false;
        }
        if (conditionsItem['fullNumber'] === '' || conditionsItem['fullNumber'] == 'undefined') {
          return false;
        }
      }
    }
  }
  if (childrenData['optionType'] !== 'DIRECT_DESCENT') {
    // 门槛规格校验（effectConditions） FULL_SUB FULL_GWP DIRECT_DESCENT
  if (childrenData['effectConditions'].length === 0 && childrenData['children'].length === 0) {
    return false;
  } else {
    for (let index = 0; index < childrenData['effectConditions'].length; index++) {
      let effectConditionsItem = childrenData['effectConditions'][index];
      if (effectConditionsItem['optionValue'] === '' || effectConditionsItem['optionValue'] == 'undefined') {
        return false;
      }
      if (effectConditionsItem['fullNumber'] === '' || effectConditionsItem['fullNumber'] == 'undefined') {
        return false;
      }
    }
  } 
      //权益信息校验
  if (childrenData['equityInformationRule']['reductionOption'] === 'DISCOUNT_RATE' ) {
    // 折扣率校验
    if (Number(childrenData['equityInformationRule']['discountValue']) > 1) {
      return false;
    }
  }
    
  }
  

  if (childrenData['equityInformationRule']['reductionOption'] == 'REDUCTION_AMOUNT') {
    // 折扣率校验
    if (
      childrenData['equityInformationRule']['discountValue'] === '' ||
      childrenData['equityInformationRule']['discountValue'] == 'undefined'
    )
      return false;
  }

  // 优先级校验
  if (
    childrenData['optionType'] === 'FULL_SUB' ||
    childrenData['optionType'] === 'FULL_GWP' ||
    childrenData['optionType'] === 'DIRECT_DESCENT'
  ) {
    if (childrenData['priority'] === '' || childrenData['priority'] == 'undefined') {
      return false;
    }
  }
  if (childrenData.children?.length) {
    return validateChildren(childrenData.children);
  }
};
const validateChildren = (children: any[]): boolean => {
  for (let index = 0; index < children.length; index++) {
    const child = children[index];
    const rst = validateChild(child);

    if (rst === false) {
      return false;
    }
  }

  return true;
};
//校验活动树字段
const testSubmitValue = (data: any): boolean => {
  if (data['children'].length == 0) {
    // 节点下没有活动方案
    return false;
  } else {
    const rst = validateChildren(data.children);
    if (!rst) {
      return false;
    }
  }
  return true;
};
@SPI.ClassFactory(
  ActionWidget.Token({
    actionType: ActionType.Server,
    name: 'create',
    model: 'deli.aries.seller.DeliAriesSellerPromotionPlan'
  })
)
export class PromotionPlanCreateAction extends ServerActionWidget {
  private __executeSuccess = true;

  protected executeAction(action: RuntimeServerAction, submitValue: SubmitValue): Promise<ClickResult> {
    const formData = submitValue.records! as ActiveRecord;
    //@ts-ignore
    const promotionDesignJson = JSON.parse(formData.promotionDesignJson);
    if (testSubmitValue(promotionDesignJson)) {
      return super.executeAction(action, submitValue);
    } else {
      OioNotification.error('错误', '请检查活动设计');
      this.__executeSuccess = false;
      return null as any;
    }
  }
  protected clickActionAfter(result: ClickResult): Promise<ClickResult> {
    if (!this.__executeSuccess) {
      return null as any;
    }

    return super.clickActionAfter(result);
  }
}
